export const actionTypePrefix = '@@ReportPageModal';
export const reduxKey = '@@ReportPageModal';
export var ReportSectionTypes;
(function(ReportSectionTypes) {
    ReportSectionTypes["Home"] = "home";
    ReportSectionTypes["Inappropriate"] = "inappropriate";
    ReportSectionTypes["SpamMalwareWarez"] = "spam-malware-warez";
    ReportSectionTypes["IpViolation"] = "ip-violation";
    ReportSectionTypes["ThirdPartyIp"] = "third-party-ip";
    ReportSectionTypes["FirstPartyIp"] = "first-party-ip";
    ReportSectionTypes["SomethingElse"] = "something-else";
    ReportSectionTypes["Mature"] = "mature";
    ReportSectionTypes["Underage"] = "underage";
    ReportSectionTypes["Explicit"] = "explicit";
    ReportSectionTypes["Block"] = "block";
    ReportSectionTypes["Misplaced"] = "misplaced";
    ReportSectionTypes["Abuse"] = "abuse";
    ReportSectionTypes["SelfHarm"] = "self-harm";
    ReportSectionTypes["Spam"] = "spam";
    ReportSectionTypes["Malware"] = "malware";
    ReportSectionTypes["Warez"] = "warez";
    ReportSectionTypes["MonetizedAi"] = "monetized-ai";
})(ReportSectionTypes || (ReportSectionTypes = {}));
export const ReportSectionForms = {
    ["third-party-ip"]: 30,
    ["first-party-ip"]: 39,
    ["mature"]: 4,
    ["underage"]: 28,
    ["explicit"]: 37,
    ["misplaced"]: 2,
    ["abuse"]: 3,
    ["self-harm"]: 45,
    ["spam"]: 44,
    ["malware"]: 32,
    ["warez"]: 33,
    ["monetized-ai"]: 46
};
export const DeprecatedQuestions = [
    57,
    96
];
